import Vue from 'vue'
import Router from 'vue-router'
import fullpath from "./fullpath";
// import Login from '@/view/creditWebsite/login/Login'
// 登录
const Login = r => require.ensure([], () => r(require('@/page/cw/view/login/Login')), 'cw/login')
// 忘记密码
const FindPass = r => require.ensure([], () => r(require('@/page/cw/view/findpass/Findpass')), 'cw/findpass')
// 404
const NotFind = r => require.ensure([], () => r(require('@/components/common/404')), 'common/404')
// 服务信息
const Service = r => require.ensure([], () => r(require('@/page/cw/view/service/Service')), 'cw/service')
// 网站信息
const Website = r => require.ensure([], () => r(require('@/page/cw/view/website/Website')), 'cw/website')
// 官网入口
const Entrance = r => require.ensure([], () => r(require('@/page/cw/view/entrance/Entrance')), 'cw/entrance')
// 信用通栏
const Banner = r => require.ensure([], () => r(require('@/page/cw/view/banner/Banner')), 'cw/banner')
// 网站体检
const Check = r => require.ensure([], () => r(require('@/page/cw/view/check/Check')), 'cw/check')
// 网站备份
const Backup = r => require.ensure([], () => r(require('@/page/cw/view/backup/Backup')), 'cw/backup')
// 网站防护
const Defend = r => require.ensure([], () => r(require('@/page/cw/view/defend/Defend')), 'cw/defend')
// 账号设置
const Set = r => require.ensure([], () => r(require('@/page/cw/view/set/Set')), 'cw/set')
// 主体
const content = r => require.ensure([], () => r(require('@/page/cw/view/Content')), 'cw/content')
// 安全服务
const SafeService = r => require.ensure([], () => r(require('@/page/cw/view/safeService/SafeService')), 'cw/safeService')
//企业信息
const enterprise  = r => require.ensure([], () => r(require('@/page/cw/view/enterprise/enterprise')), 'cw/enterprise')
//官方媒体
const official  = r => require.ensure([], () => r(require('@/page/cw/view/official/official')), 'cw/official')
//编辑官方媒体
const officialEdit  = r => require.ensure([], () => r(require('@/page/cw/view/officialEdit/officialEdit')), 'cw/officialEdit')
//服务协议
const Contract = r => require.ensure([], () => r(require('@/page/cw/view/contract/contract')), 'cw/contract')


// const officialEdit  = r => require.ensure([], () => r(require('@/page/cw/view/officialEdit/officialEdit')), 'cw/officialEdit')
// enterpriseEdit
Vue.use(Router)

var vueRouter = new Router({
    mode: 'history',
    fallback: false,
    routes: [
        {
            path: '/user/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/user/findpass',
            name: 'FindPass',
            component: FindPass
        },
        {
            path: '/user/contract',
            name: 'Contract',
            component: Contract
        },
        {
            path: '/user/404',
            name: 'NotFind',
            component: NotFind
        },

		// {
		// 	path:'/user/officialEdit',
		// 	name:'officiaEdit',
		// 	component:officialEdit
		// },
        // // /u这个路径重定向到登陆 (有bug 加上会导致登录不下去)
        // {
        //     path: '/u',
        //     redirect: '/user/login'
        // }
    ]
})

// 默认路由，包含登陆，404，忘记密码页面
export default vueRouter



// WEBPACK FOOTER //
// ./src/page/cw/router/index.js